<template>
    <form class="edit-startdesk-category" v-bind:action="apiUrl + '/startdesks/categories' + (id ? ('/' + id) : '')" v-on:submit.prevent="handleSubmit">
        <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
            <label class="form__label" for="name">{{ __('Category name') }}</label>
            <input class="form__control is-large" id="name" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter category name')"
                   v-model="name"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

        <div class="form__group" v-if="categories && categories.length > 0">
            <label class="form__label" for="parent">{{ __('Parent category') }}</label>
            <select class="form__control" id="parent"
                    v-model="parent"
                    >
                <option v-for="category in categories" v-bind:value="category.id">{{ category.name }}</option>
            </select>
            <span class="form__focus"></span>
        </div>

        <button class="btn is-primary edit-tile__save-btn" type="submit">{{ __('Save') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                categories: [],
                errors: {},
                name: '',
                parent: null
            }
        },
        methods: {
            getCategories: function () {
                this.categories = [];

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/startdesks/categories', {
                    params : {
                        page: 1,
                        perPage: 0,
                        sortBy: 'name',
                        sortOrder: 'asc'
                    }
                }).then(function (response) {
                    this.categories = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            getStartdeskCategory: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/startdesks/categories/' + this.id).then(function (response) {
                    const category = response.body;

                    this.name = category.name;
                    this.parent = category.parent_id;

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');
                const method = this.id ? 'patch' : 'post';

                eventBus.$emit('show-loader');

                this.$http[method](action, {
                    name: this.name,
                    parent_id: this.parent
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Category has been successfully saved.'));

                    this.$router.push({
                        name: 'startdesks.categories'
                    });
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            },
            init: function () {
                this.getCategories();

                if (this.id) {
                    this.getStartdeskCategory();
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            id: {
                default: null,
                type: Number
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EditStartdeskCategory.vue